// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Expanded = createIcon(
  <path
    clipRule="evenodd"
    d="M8.34502 7.3922C8.34502 6.89514 7.94209 6.49219 7.44503 6.49219C6.94797 6.49218 6.54502 6.89512 6.54502 7.39218L6.54492 16.628C6.54492 17.1251 6.94786 17.528 7.44491 17.528C7.94197 17.528 8.34492 17.1251 8.34492 16.6281L8.34502 7.3922ZM17.2256 8.03956C17.5771 7.68809 17.5771 7.11824 17.2256 6.76677C16.8741 6.4153 16.3043 6.4153 15.9528 6.76677L11.3564 11.3632C11.0049 11.7147 11.0049 12.2845 11.3564 12.636L15.9528 17.2324C16.3043 17.5839 16.8741 17.5839 17.2256 17.2324C17.5771 16.881 17.5771 16.3111 17.2256 15.9596L13.2656 11.9996L17.2256 8.03956Z"
    fillRule="evenodd"
  />,
);
